import { ShowSideMenuType } from '../actions/actionTypes';
// const chosenSidebarReducer = (state= '', action) => {
//     console.log("sideMenuReducer chosenSidebarReducer action: " + JSON.stringify(action.type))

//     switch(action.type) {
        
//         case SidebarType.HOME:
//             return action.type

//         case SidebarType.REPORTS:
//             return action.type

//         case SidebarType.SETTINGS:
//             return action.type

//         case SidebarType.NOTIFICATIONS:
//             return action.type                 
            
//         default:
//             return state;

//     };
// };

const showSideMenuReducer = (state='', action) => {
    switch(action.type) {
        // case ShowSideMenuType.SHOWSIDEMENU:
        //     return action.type
        // case ShowSideMenuType.HIDESIDEMENU:
        //     return action.type
        default: 
            return state;
    };
};


//export default (chosenSidebarReducer, showSideMenuReducer);
export default showSideMenuReducer;
